import CurrencyField from './currency-field';
export default CurrencyField;
